/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Units_ImperialInputs */

const en_us2_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb and mi`)
};

const pt_br2_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb e mi`)
};

const es_419_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb y mi`)
};

const pt_pt2_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb e mi`)
};

const fr_fr2_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb et mi`)
};

const de_de2_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb und mi`)
};

const it_it2_history_transfer_units_imperial = /** @type {(inputs: History_Transfer_Units_ImperialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb e mi`)
};

/**
* | output |
* | --- |
* | "lb and mi" |
*
* @param {History_Transfer_Units_ImperialInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_units_imperial = /** @type {((inputs?: History_Transfer_Units_ImperialInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Units_ImperialInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_units_imperial(inputs)
	if (locale === "es-419") return es_419_history_transfer_units_imperial(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_units_imperial(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_units_imperial(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_units_imperial(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_units_imperial(inputs)
	return en_us2_history_transfer_units_imperial(inputs)
});
export { history_transfer_units_imperial as "history-transfer.units_imperial" }